import { NoticeType } from './NoticeType';

export const NoticeTypeOptions = [
    {
        id: NoticeType.AdverseAction,
        name: 'Adverse Action Notice',
    },
    {
        id: NoticeType.AppraisalNotice,
        name: 'Appraisal Notice',
    },
    {
        id: NoticeType.AppraisalReport,
        name: 'Appraisal Report Notice',
    },
    {
        id: NoticeType.FloodNotice,
        name: 'Flood Notice',
    },
    {
        id: NoticeType.IncompleteFile,
        name: 'Incomplete File Notice',
    },
];
